import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'kh-card',
    styleUrls: ['./card.component.less'],
    templateUrl: './card.component.html',
    standalone: false
})
export class CardComponent implements OnInit{
	@Input() text: string | undefined = undefined;
	@Input() iconUrl: string | undefined = undefined;
	@Input() width: number = 140;
	@Input() height: number = 140;
	@Input() isSelected: boolean = false;
	
	public showIcon: boolean = false;

	ngOnInit(): void {
		this.showIcon = !!this.iconUrl;
	}
}
